import invariant from "invariant";

import { beginImageUpload } from "./cloudflare.action";
import { type IdOf, isId } from "./id";

export type ImageOptions = RequestInitCfPropertiesImage

export function getImageUrl(imageId: IdOf<"image">, options: ImageOptions = {}) {
	invariant(isId("image", imageId), "Invalid image ID");

	const transformations = Object.entries(options)
		.sort(([a], [b]) => a.localeCompare(b))
		.map(([key, value]) => `${key}=${value}`)
		.join(",");

	return `https://files.adli.ly${transformations ? `/cdn-cgi/image/${transformations}` : ""}/${imageId}`;
}

export async function uploadImage(blob: Blob) {
	const { id, url } = await beginImageUpload();

	const response = await fetch(url, {
		method: "PUT",
		body: blob,
		headers: {
			// Never overwrite existing images, as they are immutable.
			"if-unmodified-since": new Date(0).toUTCString(),
		}
	});

	if (!response.ok)
		throw new Error(`Couldn't upload image: ${response.statusText}`, { cause: response });

	return id;
}
